import React, { FC, useState, useEffect, useContext } from 'react'
import { isMobile } from 'react-device-detect'
import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericButton from '../../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../../GenericComponents/GenericCloseButton'

import {
  SingleSettingModalBox,
  UserDataContainer,
} from '../../style/UserProfileStyle'

interface AgreementsInterface {
  closeModal: Function
}

const Agreements: FC<AgreementsInterface> = ({ closeModal }) => {
  return (
    <SingleSettingModalBox>
      <GenericCloseButton onClick={closeModal} />
      <GenericRow margin={'0% 0 3% 0'}>
        <GenericTextSpan fSize={'2rem'} fWeight={'bold'}>
          Regulamin
        </GenericTextSpan>
      </GenericRow>

      <GenericRow>
        <GenericTextSpan
          width={isMobile ? '90%' : '60%'}
          fSize={'1.3rem'}
          tAlign={'center'}
          margin={'2% 0'}
        >
          <a
            href="https://fitmatkawariatka.pl/regulamin-aplikacji-od-03-01-2022-r/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Regulamin aplikacji (od 03.01.2022 r.) - Fit Matka Wariatka
          </a>
        </GenericTextSpan>
      </GenericRow>

      <GenericRow>
        <GenericTextSpan
          width={isMobile ? '90%' : '60%'}
          fSize={'1.3rem'}
          tAlign={'center'}
          margin={'2% 0'}
        >
          <a
            href="https://fitmatkawariatka.pl/regulamin-aplikacji-miazga-nowy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Regulamin aplikacji (od 15.10.2020 r.)
          </a>
        </GenericTextSpan>
      </GenericRow>

      <GenericRow>
        <GenericTextSpan
          width={isMobile ? '90%' : '60%'}
          fSize={'1.3rem'}
          tAlign={'center'}
          margin={'2% 0'}
        >
          <a
            href="https://fitmatkawariatka.pl/regulamin-aplikacja-miazga/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Regulamin aplikacji (od 28.11.2019 r.)
          </a>
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericTextSpan
          width={isMobile ? '90%' : '60%'}
          fSize={'1.3rem'}
          tAlign={'center'}
          margin={'2% 0'}
        >
          <a
            href="https://fitmatkawariatka.pl/potwierdzenie-zawarcia-umowy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Potwierdzenie zawarcia umowy
          </a>
        </GenericTextSpan>
      </GenericRow>
    </SingleSettingModalBox>
  )
}

export default Agreements
